import classes from "../JoinQuizPage/OpenEndedResult.module.css";
import {
    NO_RESPONSES_TEXT, OE_NO_RESPONSE_EXPLAIN, SA_NO_RESPONSE_EXPLAIN_RELEASE_PAGE,
    OPEN_ENDED_DISLIKE_SORT,
    OPEN_ENDED_LIKE_SORT,
    OPEN_ENDED_TIME_SORT,
    YUJA_DROPDOWN_SIZE
} from "../../utils/constants";
import {YuJaDropdown} from "../../components/standardization/YuJaDropdown";
import { ReactComponent as NoResultIllustration } from "../../images/notGradedAttendance.svg";
import React, {Fragment, useEffect, useState} from "react";
import classResultClasses from "../JoinQuizPage/ClassResult.module.css";

/**
 *
 * @param originalData [ { "selectedOption": {comment},  "openEndedCount": {  "1": {likeCount},  "2": {dislikeCount} } },....]
 * @returns {Element}
 * @constructor
 */


export default function ViewLiveRespOE({originalData}) {
    const [sortOption, setSortOption] = useState(OPEN_ENDED_TIME_SORT);
    const [data, setData] = useState([]);

    const handleSort = () => {
        let entries = JSON.parse(JSON.stringify(originalData));
        if (sortOption === OPEN_ENDED_TIME_SORT) {
            setData(entries);
        } else if (sortOption === OPEN_ENDED_LIKE_SORT && originalData && originalData.length > 1) {
            entries.sort((a, b) => {
                const {openEndedCount: openEndedCountA={}} = a;
                const {openEndedCount: openEndedCountB={}} = b;
                const countA = !!openEndedCountA["1"] ? openEndedCountA["1"] : 0;
                const countB = !!openEndedCountB["1"] ? openEndedCountA["1"] : 0;
                return countB - countA;
            });
            setData(entries);
        } else if (sortOption === OPEN_ENDED_DISLIKE_SORT && originalData  && originalData.length > 1) {
            entries.sort((a, b) => {
                const {openEndedCount: openEndedCountA={}} = a;
                const {openEndedCount: openEndedCountB={}} = b;
                const countA = !!openEndedCountA["2"] ? openEndedCountA["2"] : 0;
                const countB = !!openEndedCountB["2"] ? openEndedCountA["2"] : 0;
                return countB - countA;
            });
            setData(entries);
        }
    }


    useEffect(() => {
        handleSort();
    }, [sortOption, originalData])

    return (
        <div className={classResultClasses.chartContainerBody}>
            <YuJaDropdown
                size={YUJA_DROPDOWN_SIZE.SMALL}
                data={[OPEN_ENDED_TIME_SORT, OPEN_ENDED_LIKE_SORT, OPEN_ENDED_DISLIKE_SORT]}
                getOptionLabel={item => item}
                getOptionValue={item => item}
                onChange={option => setSortOption(option)}
                value={sortOption}
                containerStyle={{width: 130, alignSelf: "end"}}
            />
            <div className={classes.body} style={{padding: 0}}>
                {!!originalData && !!originalData.length &&
                    data?.map((entry, index) => {
                        const {selectedOption, openEndedCount={}} = entry;
                        const likeCount = !!openEndedCount["1"] ? openEndedCount["1"] : 0;
                        const disLikeCount = !!openEndedCount["2"] ? openEndedCount["2"] : 0;
                        return (
                            <div
                                key={index}
                                className={classes.responseCard}
                                style={{
                                    borderRadius: 4,
                                    backgroundColor: "#F6F6F6E6",
                                    border: "1px solid #E6E6E6"
                                }}
                            >
                                <span>{selectedOption}</span>
                                <span className={classes.likeAndDislikeContainer} style={{backgroundColor: "#E6E6E6"}}>
                                    <span className={`${classes.thumbUpIcon} ${classes.nonHover} `}/>
                                    <span style={{fontSize: 15, fontWeight: 500, color: "#4D4D4D"}}> {likeCount} </span>
                                    <span style={{flex: 1}}/>
                                    <span className={`${classes.thumbDownIcon} ${classes.nonHover}`}/>
                                    <div style={{fontSize: 15, fontWeight: 500, color: "#4D4D4D"}}> {disLikeCount} </div>
                                </span>
                            </div>
                        );
                    })
                }

                {(!originalData || !originalData.length) &&
                    <>
                        <NoResultIllustration width={130} height={71} style={{alignSelf: "center"}}/>
                        <span style={{fontSize: 16, fontWeight: 600, alignSelf: "center"}}>
                            {NO_RESPONSES_TEXT}
                        </span>
                        <span style={{fontSize: 14, lineHeight: 1.6, fontWeight: 400, alignSelf: "center"}}>
                          {SA_NO_RESPONSE_EXPLAIN_RELEASE_PAGE}
                      </span>
                    </>
                }
            </div>
        </div>
    );

}